import { render, staticRenderFns } from "./GratitudeAndSuggestionTicket.vue?vue&type=template&id=4b494430&scoped=true"
import script from "./GratitudeAndSuggestionTicket.vue?vue&type=script&lang=js"
export * from "./GratitudeAndSuggestionTicket.vue?vue&type=script&lang=js"
import style0 from "./GratitudeAndSuggestionTicket.vue?vue&type=style&index=0&id=4b494430&prod&lang=scss&scoped=true"
import style1 from "./GratitudeAndSuggestionTicket.vue?vue&type=style&index=1&id=4b494430&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b494430",
  null
  
)

export default component.exports